module.exports = __webpack_public_path__ + "img/logo_sm.dc438324.png";